import {eye} from 'assets/images/images';
import {DashboardLayout, SearchInput, TableLayout} from 'components';
import CardSummary from 'components/CardSummary';
import React from 'react';
import {useNavigate} from 'react-router';

function VeldroBusinesses() {
  const navigate = useNavigate();

  const tableHeader = [
    {label: 'name', key: 'name'},
    {label: 'Email Address', key: 'email'},
    {label: 'ID', key: 'value'},
    {label: 'TIN', key: 'status'},
    {label: 'Action', key: 'action'},
  ];

  return (
    <DashboardLayout
      breadCrumbs={
        <p className="text-tiny font-normal text-deepBlue">Businesses</p>
      }
    >
      <div className="flex items-center py-2 flex-wrap gap-3 justify-between mx-[-32px] px-8 border border-transparent border-b-[#E4E3EC]">
        <div className="flex items-center gap-2 flex-wrap">
          <SearchInput placeholder="Search here" />
        </div>
      </div>

      <div className="flex-wrap py-6">
        <CardSummary title="Total no. of Businesses" body="1" />
      </div>

      <TableLayout negativeMargins>
        <thead className="font-semibold uppercase">
          <tr className="bg-white80">
            {tableHeader.map(({label, key}) => (
              <th
                key={key}
                className={`${
                  label === 'name' ? 'pl-4 sm:pl-6 xl:pl-8' : 'pl-0'
                } h-11 font-medium text-left text-small text-[#5C688E] whitespace-nowrap`}
              >
                <div className="flex items-end gap-1 cursor-pointer">
                  <span>{label}</span>
                </div>
              </th>
            ))}
            <th></th>
          </tr>
        </thead>
        <tbody className="text-sm bg-white">
          <tr
            onClick={() =>
              navigate(
                '/businesses/veldro/6df03c76-1d83-4a39-a4de-51bd70547aef',
              )
            }
            className="border-[0.5px] border-[#E4E3EC] cursor-pointer"
          >
            <td className="p-4 pl-4 sm:pl-6 xl:pl-8 text-body whitespace-nowrap capitalize">
              Test Business
            </td>
            <td className="p-4 pl-0 text-body whitespace-nowrap">
              testbusiness@gmail.com{' '}
            </td>
            <td className="p-4 pl-0 text-body whitespace-nowrap">
              6df03c76-1d83-4a39-a4de-51bd70547aef{' '}
            </td>
            <td className="p-4 pl-0 text-body whitespace-nowrap">
              83003756-4994
            </td>

            <td className="p-4 pl-0 whitespace-nowrap">
              <button title="View" className="h-4 aspect-square">
                <img src={eye} alt="View" />
              </button>
            </td>
          </tr>
        </tbody>
      </TableLayout>
    </DashboardLayout>
  );
}

export default VeldroBusinesses;
